module.exports = __webpack_public_path__ + "static/media/incentives-screenshot.06f94199.png";